import React from 'react';
import { Calculator, MapPin, Mail, Phone, Heart } from 'lucide-react';
import '../../Style/Pages/footer.css';
import { Link, useNavigate } from "react-router";
import logo from '../../Assest/logo.png'
const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">
                <img src={logo} width={100} />
                {/* <Calculator className="h-6 w-6 text-white" /> */}
              </div>
              <div>
                <h3 className="footer-logo-text">Amigo Math</h3>
                <p className="footer-logo-tagline">Calculating Success Together</p>
              </div>
            </div>
            <p className="footer-description">
              Empowering young minds through innovative abacus-based mathematics education.
              Building confidence, concentration, and problem-solving skills for life.
            </p>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin className="footer-contact-icon" />
                <span className="footer-contact-text">
                  NO21, Sri Lakshmi Narayani Nagar, Sripuram, Vellore 632055
                </span>
              </div>
              <div className="footer-contact-item">
                <Phone className="footer-contact-icon" />
                <span className="footer-contact-text">+91 63836 45110</span>
              </div>
              <div className="footer-contact-item">
                <Mail className="footer-contact-icon" />
                <span className="footer-contact-text">amigomathofficial@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className='footer-links-main'>
            <div className="footer-section">
              <h4 className="footer-section-title">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to='/'
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('courses')}
                    className="footer-link"
                  >
                    Courses
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('why-us')}
                    className="footer-link"
                  >
                    Why Us
                  </button>
                </li>
                <li>
                  {/* <button 
                  onClick={() => scrollToSection('about')}
                  className="footer-link"
                >
                  About
                </button> */}
                </li>
                <li>
                  <Link
                    to='contact'
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Programs */}
            <div className="footer-section">
              <h4 className="footer-section-title">Our Programs</h4>
              <ul className="footer-programs">
                <li>
                  <span className="footer-program">KIDDY (Ages 5 - 8)</span>
                </li>
                <li>
                  <span className="footer-program">BUDDY (Ages 9-15)</span>
                </li>
                <li>
                  <span className="footer-program">Abacus Training</span>
                </li>
                {/* <li>
                <span className="footer-program">Mental Math</span>
              </li>
              <li>
                <span className="footer-program">Olympiad Prep</span>
              </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © 2024 Amigo Math. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;